"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserBooleanComponentParameters = void 0;
exports.UserBooleanComponentParameters = [
    {
        id: 'true_label',
        label: 'True Label',
        description: 'Input Param - The label that is to be mapped to the true boolean value',
        type: 'string',
        required: true,
        paramType: 'STRING',
    },
    {
        id: 'false_label',
        label: 'False Label',
        description: 'Input Param - The label that is to be mapped to the false boolean value',
        type: 'string',
        required: true,
        paramType: 'STRING',
    },
    {
        id: 'selected',
        label: 'Selected Value',
        description: 'Output Param - The boolean value selected by user',
        type: 'output',
        paramType: 'BOOLEAN',
        required: true,
    },
];
//# sourceMappingURL=UserBooleanComponent.js.map